import classNames from 'classnames';
import type { ReactNode } from 'react';
import DisplayTrapNameId from '@features/regional-overview/digital-traps/components/display-trap-name-id';
import { SevenDayTotalTag } from '@features/regional-overview/digital-traps/components/seven-day-total-tag';
import type { Status } from '@features/regional-overview/digital-traps/components/status-tag/status-tag.model';
import styles from './daily-counts-card.module.css';

export interface DailyCountsCardProps {
  trapName: string;
  trapId: string;
  total: number | string;
  status: Status;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  dataTestId?: string;
}

export const DailyCountsCard = ({
  trapName,
  trapId,
  total,
  status,
  children,
  className,
  contentClassName,
  dataTestId
}: DailyCountsCardProps) => (
  <article className={classNames(styles.card, className)} data-testid={dataTestId}>
    <div className={styles.identity}>
      <DisplayTrapNameId trapName={trapName} trapId={trapId} />
    </div>
    <SevenDayTotalTag total={total} status={status} className={styles.total} />
    <div className={classNames(styles.content, contentClassName)}>{children}</div>
  </article>
);
